import { compareId } from '../../helpers';
import { addTotalCadastreCount } from '../../helpers/cadastreForms/getFormField';
import {responsiblePersonsFormsPercentGetter} from "./responsiblePersonsFormsPercentGetter";

const transportedWasteField = [
  { name: 'waste_type_id', valid: (waste_type_id) => waste_type_id?.id || compareId(waste_type_id?.name, 0) },
  { name: 'waste_management_type_ids', valid: (waste_management_type_ids, { waste_type_id }) => waste_management_type_ids?.[0]?.id || compareId(waste_type_id?.name, 0) },
  'actual_volume_transported_waste',
  { name: 'accept_subject_id', valid: (accept_subject_id) => accept_subject_id?.id || compareId(accept_subject_id?.name, 0) },
];

export const getInitialForm6TransportedWaste = () => ({
  randId: Math.random(),
  waste_type_id: '',
  actual_volume_transported_waste: '',
  waste_management_type_ids: [],
  accept_subject_id: '',
});

export const FORM6_TRANSPORTED_WASTE = 'transportedWastes';

export const getInitialForm6ActualVolume = () => ({
  randId: Math.random(),
  [FORM6_TRANSPORTED_WASTE]: [getInitialForm6TransportedWaste()],
  objective_id: '',
});

export const getInitialForm6 = () => ({
  actualVolumes: [getInitialForm6ActualVolume()],
});

export const form6PercentGetter = (forms, { errorSetter }) => {
  const { actualVolumes } = forms.form6;

  let allDataLength = 0;
  let allFilledData = 0;

  const addTransportedWasteCount = (count) => {
    allDataLength += count;
  };
  const addFilledCount = () => {
    allFilledData += 1;
  };

  const newErrors = [];

  actualVolumes[0].transportedWastes.forEach((transportedWaste) => {
    addTransportedWasteCount(transportedWasteField.length);
    addTotalCadastreCount(transportedWasteField, transportedWaste, addFilledCount, { errorSetter: () => newErrors.push(`transportedWaste${actualVolumes[0].randId}${transportedWaste.randId}`) });
  });

  if (allDataLength === 0) return 0;
  responsiblePersonsFormsPercentGetter(forms.form6, (count) => (allDataLength += count), addFilledCount);

  errorSetter({ errorForm6: newErrors });

  return Math.floor((allFilledData / allDataLength) * 100);
};
